import { guuid, isNeString } from '@aretheyhappy/utils';
/**
 * Definition for items that appear in a List.vue
 */
class ListItem {
    constructor(label, onClick, icon = '') {
        this.uid = guuid();
        this.label = '';
        this.subtitle = '';
        this.icon = '';
        this.qa_tag = '';
        this.active = false;
        this.onClick = () => { };
        this.label = label;
        this.onClick = onClick;
        this.icon = icon;
        this.qa_tag = this.uid;
    }
    setLabel(label) { this.label = label; return this; }
    setSubtitle(subtitle) { this.subtitle = subtitle; return this; }
    setOnClick(onClick) { this.onClick = onClick; return this; }
    setIcon(icon) { this.icon = icon; return this; }
    setQATag(tag) { this.qa_tag = tag; return this; }
    setActive(value) { this.active = value; return this; }
    get hasSubtitle() {
        return isNeString(this.subtitle);
    }
}
export { ListItem };
export default ListItem;
//# sourceMappingURL=ListItem.js.map